import type { ReadRow } from './ReadGrid';

/** One read-only value: the row's empty treatment when blank, otherwise the
 *  value itself, muted for a placeholder and monospace when asked. */
export function ReadGridValue({ row }: { row: ReadRow }) {
  const empty = row.value === null || row.value === undefined || row.value === '';
  if (empty) {
    return (
      row.emptyContent ?? (
        <span style={{ fontSize: 12.5, color: 'var(--nb-faint)', fontStyle: 'italic' }}>
          Not set
        </span>
      )
    );
  }
  return (
    <div
      className={row.mono ? 'nb-mono' : undefined}
      style={{
        fontSize: 13,
        color: row.muted ? 'var(--nb-muted)' : 'var(--nb-ink)',
        fontStyle: row.muted ? 'italic' : undefined,
        lineHeight: 1.45,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {row.value}
    </div>
  );
}
